module.exports = __webpack_public_path__ + "img/background-technology-mobile.4f5b72f2.jpg";